export default __webpack_public_path__ + "static/media/logo.bccc8817.png";